import AppConstants from 'constants/AppConstants';

interface SyndicateState {
  // An identifier that can be attached to API requests
  syndicate?: string;
}

const initialState: SyndicateState = {
  syndicate: undefined,
};

export default function reducer(
  state: SyndicateState = initialState,
  action: BaseTockAction
): SyndicateState {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.SYNDICATE_SET: {
      return {
        ...state,
        ...payload,
      };
    }
    case AppConstants.SYNDICATE_CLEAR: {
      return {
        ...state,
        syndicate: undefined,
      };
    }
    default:
      return state;
  }
}
